var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnKnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.17,
    height: 31.17,
    viewBox: "0 0 31.17 31.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unknew",
    transform: "translate(-3969.819 -1954.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M4000.989,1964.337v17.39a4.421,4.421,0,0,1-4.42,4.42h-22.33a4.421,4.421,0,0,1-4.42-4.42V1959.4a4.421,4.421,0,0,1,4.42-4.42h17.39Z",
    fill: "#da73ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M3991.629,1959.917v-4.94l9.36,9.36h-4.94A4.422,4.422,0,0,1,3991.629,1959.917Z",
    fill: "#d44190"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3103",
    "data-name": "Rectangle 3103",
    width: 19,
    height: 2.333,
    rx: 1.167,
    transform: "translate(3975.904 1965.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3104",
    "data-name": "Rectangle 3104",
    width: 19,
    height: 2.333,
    rx: 1.167,
    transform: "translate(3975.904 1970.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3105",
    "data-name": "Rectangle 3105",
    width: 19,
    height: 2.333,
    rx: 1.167,
    transform: "translate(3975.904 1975.145)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnKnow);
export default __webpack_public_path__ + "static/media/unKnow.ef6bf4e1ca8f7d1976e5f3efc2e2b765.svg";
export { ForwardRef as ReactComponent };